<ng-container *ngIf="(userInfo && !loading); else waiting">

    <div class="row">
        <!-- sezione ricerca -->
        <app-advanced-search [customSearch]="advSearch.getConfigAdv()" (callSearch)="searchParams($event)" (callButton)="callButton($event)"></app-advanced-search>
        <div *ngIf="primaRicerca">
            <h5 title="Rimuovere i filtri di ricerca renderà la ricerca molto lenta e potrebbe non restituire risultati in quanto la richiesta va in timeout">Ricerca di default attivata - vengono mostrati i documenti dell'anno corrente {{this.anno}}</h5>
        </div>
        <hr>
    </div>
    <ng-container *ngIf='dataTable;else waiting'> 
    <div class="row" style="margin-bottom: 10px;" *ngIf="dataTable.length>0">
        <div [ngClass]="{'col' : innerWidth! > 767, 'col-12': innerWidth! <= 767}" class="text-center text-md-left">
            <!--<div style="float: right; display: flex; align-items: start;white-space: nowrap;">-->
                <div class="d-inline-block" style="float:left">
                    <button type="button" class="btn btn-light btn-sm mb-1 w-xs-100" style="margin-right: 5px" 
                        (click)='downloadSelected()'><i class="bi bi-download"></i> {{'invoices.button.downloadSelected' | translate}}</button>
                    <button type="button" class="btn btn-light btn-sm mb-1 w-xs-100" style="margin-right: 5px"
                        (click)='setDownload(2)'><i class="bi bi-file-check"></i> {{'invoices.button.alreadyDownloaded' | translate}}</button>
                    <button type="button" class="btn btn-light btn-sm mb-1 w-xs-100" style="margin-right: 5px "
                        (click)='setDownload(0)'><i class="bi bi-file-earmark-arrow-down"></i> {{'invoices.button.toDownload' | translate}}</button>
                    <button type="button" class="btn btn-light btn-sm mb-1 w-xs-100" style="margin-right: 5px" 
                        (click)='downloadCSV()'><i class="bi bi-file-earmark-excel"></i> {{'invoices.button.downloadSelectedExcel' | translate}}</button>
                    <!--<div ngbDropdown class="d-inline-block" style="margin-right: 5px">
                        <button type="button" class="btn btn-warning btn-sm mb-1 w-xs-100" id="dropdownBasic3"
                            ngbDropdownToggle style="margin-right: 0px "><i class="bi bi-download"></i>
                            {{'invoices.button.downloadSelected'
                            |
                            translate}}</button>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic3">
                            <button ngbDropdownItem (click)='downloadSelected()'>{{'invoices.dropdown.downloadSelected'
                                |
                                translate}}</button>
                            <button ngbDropdownItem (click)="downloadAll('DWNZIPA');">{{'invoices.dropdown.downloadAll' |
                                translate}}</button>
                        </div>
                    </div>

                    
                    <div ngbDropdown class="d-inline-block" style="margin-right: 5px">
                        <button type="button" class="btn btn-secondary btn-sm mb-1 w-xs-100" style="margin-right: 5px"
                            id="dropdownBasic4" ngbDropdownToggle><i class="bi bi-file-earmark-excel"></i>
                        {{'invoices.button.downloadSelectedExcel' | translate}}</button>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic4">
                            
                            <button ngbDropdownItem (click)="downloadAll('DWNCSVA');">{{'invoices.dropdown.downloadAll' |
                                translate}}</button>
                        </div>
                    </div>-->
                    <div ngbDropdown class="d-inline-block"  style="margin-right: 5px">
                        <button class="btn btn-light btn-sm mb-1 w-xs-100" id="dropdownBasic2" ngbDropdownToggle
                            style='margin: 0px'>
                            <i class="bi bi-file-earmark-pdf"></i> {{'invoices.button.generateAndDownloadSelectedPDF' |
                            translate}}
                        </button>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic2">
                            <button ngbDropdownItem (click)="downloadPDF('')">{{'invoices.dropdown.assoFormat' | translate}}</button>
                            <button ngbDropdownItem (click)="downloadPDF('min');">{{'invoices.dropdown.minFormat' | translate}}</button>
                            <button ngbDropdownItem (click)="downloadPDFCombi('');">{{'invoices.dropdown.allAssoFormat' | translate}}</button>
                            <button ngbDropdownItem (click)="downloadPDFCombi('min');">{{'invoices.dropdown.allMinFormat' | translate}}</button>
                        </div>
                    </div>
                    <!--<div *ngIf="labels" ngbDropdown class="d-inline-block"  style="margin-right: 1rem;">
                        <button class="btn btn-secondary btn-sm mydropdown" id="dropdownBasic3" ngbDropdownToggle>
                        <i class="bi bi-tags"></i> {{'invoices.button.labels' | translate}}
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic3">
                            <button *ngFor='let label of labels' ngbDropdownItem (click)='assignTag(label)'>
                            <img [src]="'assets/icone_varie/tag_' +label.style +'.svg'"
                             style='width:16px;height:auto'>
                            {{label.etichetta}} 
                        </button>
                       
                    </div>
                </div>-->
                </div>
                <!--</div>-->
            </div>
        </div>
        <div>
            <div class="row justify-content-between" style="margin-bottom: 10px; margin-top:10px">
                <div class='col-auto' style="display: flex; flex-direction: row;">
                    <label class="form-check-label" style='margin-right: 5px;'>{{'general.show' | translate}}</label>
                    <div class="dm7Select">
                        <div class="select-side">
                            <img src="assets/icone_varie/arrow_down.svg">
                        </div>
                        <app-select class="selectDm7" 
							[options]="pages" [key]="'key'" [value]="'key'"
                            [placeholder]="'placeholder.select' | translate" [addNull]="false" [selectedKey]="params.get('pageSize')" 
							(change)="changePageSize($event.key)"></app-select>
                    </div>
                    <label class="form-check-label">{{'paginator.rows' | translate}}</label>
                </div>
                <div class='col-auto' style="float: right;">
                    <app-paginator *ngIf="paginator" [config]="paginator" (refresh)="getDataTable()" (next)="next()"
                        (prev)="prev()" (setPage)="setPage($event)"></app-paginator>
                </div>
            </div>
            <div class="row justify-content-between" style="margin-bottom: 10px; margin-top:10px">
                <div class='col-auto' style="float: right;">
                    {{file_selected}} {{'invoices.selectedFiles' | translate}} <button *ngIf="file_selected > 0"
                        type="button" class="btn btn-sm mb-1 w-xs-100" style="margin-left: 10px "
                        (click)='deselectAll()'><i class="bi bi-x-circle"></i>
                        {{'invoices.undoSelection' | translate}}</button>
                </div>
            </div>
            <div *ngIf="dataTable.length>0; else noRes">
                <table class="table table-sm">
                    <thead>
                        <tr>
                            <th scope="col" style="max-width: 40px; width: 30px;"></th>
                            <th scope="col" style=" max-width: 40px; width: 30px;"><input type="checkbox" style="margin-left:-4px;" class="form-check-input" id="predef" [(ngModel)]="allSelected" (ngModelChange)="setSelected()"></th>
                            <th scope="col" class="d-print-none" style="max-width: 60px; width: 60px;"> {{'invoices.table.tipo' | translate}}</th>
                            <th scope="col">{{'invoices.table.num' | translate}}</th>
                            <th scope="col" style="max-width: 100px; width: 100px;">{{'invoices.table.date' | translate}}</th>
                            <th scope="col" colspan="2" (click)="sort('Denominazione')" style="cursor: pointer;min-width: 400px !important;">{{'invoices.table.receiver' | translate}}<img [src]="'assets/icone_varie/' + sortUtils.getImgSort('Denominazione')" style="width: 20px;"></th>
                            <th scope="col" style="max-width: 60px; width: 60px;">{{'invoices.table.amount' | translate}}</th>
                            <th scope="col">{{'invoices.table.status' | translate}}</th>
                            <th scope="col" class="d-print-none">
                                {{'invoices.table.sdi' | translate}}
                                <br />{{'invoices.table.dateTimeReceived' | translate}}
                            </th>
                            <!--<th scope="col" class="d-print-none">{{'invoices.table.dateTimeReceived' | translate}}</th>-->
                            <th scope="col" style="max-width: 60px; width: 60px;" class="d-print-none"> {{'invoices.table.notific' | translate}}</th>
                            <th scope="col" colspan="2" class="d-print-none" (click)="sort('date_created')"> {{'invoices.table.fileName' | translate}}<br />{{'invoices.table.dateCreated' | translate}} <img [src]="'assets/icone_varie/' + sortUtils.getImgSort('date_created')" style="width: 20px;"></th>
                            <!--<th scope="col" class="d-print-none" (click)="sort('file_name')" style="cursor: pointer;">{{'invoices.table.fileName' | translate}} <img [src]="'assets/icone_varie/' + sortUtils.getImgSort('file_name')" style="width: 20px;"></th>
                       
                        <th scope="col" class="d-print-none" (click)="sort('date_created')" style="cursor: pointer;">{{'invoices.table.dateCreated' | translate}} <img [src]="'assets/icone_varie/' + sortUtils.getImgSort('date_created')" style="width: 20px;"></th>-->
                        <th scope="col" style="max-width: 60px; width: 60px;">{{'invoices.table.actions' | translate}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of dataTable; index as i;" [ngClass]="{'draft':item.stato === 'Bozza'}" >
                        <td >
                            <div style='display: flex; flex-direction: column;'>
                                <img [src]="'assets/icone_varie/' + (item.download==1 ? 'check_1' : item.download==0? 'email': 'download') + (item.stato === 'Bozza'? '_rosso.svg' : '.svg') " [ngbTooltip]= "(getTooltip(item) | translate)" style='width:16px;height:auto; margin-bottom : 10px'>
                                <!--<ng-container *ngIf='getTag(item.tags).length>0'>
                                    <img [ngbTooltip]= "getTag(item.tags)[1]"[src]="'assets/icone_varie/tag_' +getTag(item.tags)[0] +'.svg' " style='width:16px;height:auto'>
                                </ng-container>-->
                            </div>
                        </td>
                        <td>
                            <div class="form-group form-check">
                                <input type="checkbox" class="form-check-input" id="predef" [(ngModel)]="item.selected" (ngModelChange)="checkAllSelected()" (click)='$event.stopPropagation();'>
                            </div>
                        </td>
                        <td >
                            <div style='display: flex; flex-direction: column;' (click)='openPreviewAr4m(item.id, item.file_name, i)' [ngbTooltip]="item.tipoTooltip" class="d-print-none" [ngStyle]="{'color':  item.tipo_fattura == 'TD04' ? 'red' : 'black'}">
                                {{item.tipo_fattura}}
                            </div>
                        </td>
                        <td >
                            <div style='display: flex; flex-direction: column;' (click)='openPreview(item.id, item.file_name, i)' [ngbTooltip]="item['Numero fattura']">
                                {{item.numero_fattura}}
                            </div>
                        </td>
                        <td (click)='openPreview(item.id, item.file_name, i)'>{{stringToDate(item.data_fattura!, "DD-MM-YYYY")}}</td>
                        <td colspan="2"  (click)='openPreview(item.id, item.file_name, i)'>{{item.denominazione}}</td>
                        <td>
                            <div style='display: flex; flex-direction: column;' (click)='openPreview(item.id, item.file_name, i)' [ngbTooltip]="'Imponibile: ' + item.imponibile + ', imposta: ' + item.imposta">
                                {{formatNumber(item.importo)}}
                            </div>
                        </td>
                        <td (click)='openPreview(item.id, item.file_name, i)'><strong>{{item.stato}}</strong>
                              <span *ngIf='item.stato=="Scartata" && isInvisibileInDashboard(item.tags)'>
                                    <img src="assets/icone_varie/not_eye.svg" style='width:15px' [ngbTooltip]="('invoices.table.tooltips.dashboardInvisible'| translate)">
                              </span>
                        </td>
                        <td class="d-print-none">
                            {{item.identificativo_sdi}}
                            <br>{{stringToDate(item.data_invio, "DD-MM-YYYY HH:mm")}}
                        </td>
                        <td width="2%" class="d-print-none btnCol">
                            <div ngbDropdown class="d-inline-block">
                                <card class='ghost' id="dropdownBasicNot" ngbDropdownToggle (click)='$event.stopPropagation(); getNotifications(item.notifica)'>
                                    {{item.notifica.length}}
                                    <img [src]="'assets/icone_varie/notifica' + (item.stato=='bozza'? '_rosso.svg' : '.svg')"
                                    style='width:15px' >
                                </card>
                                <div ngbDropdownMenu aria-labelledby="dropdownBasicNot" *ngIf='item.notifica.length > 0' >
                                      <button *ngFor ='let n of notifications' [ngbTooltip]="(item.stato=='Scartata') ? n.errori : ''" ngbDropdownItem (click)="$event.stopPropagation();openNotification(item.id, n.id, n.file_name)">{{n.file_name}}</button> 
                                </div>
                            </div>
                        </td>
                        <td colspan="2" style=' word-break: break-all;' class="d-print-none">{{item.file_name}} 
                            <img *ngIf="(item.conservato).toString() == '1'" title="Conservato" [src]="'assets/icone_varie/seal.svg' " style='width:16px; height:auto'>
                            <!--<img *ngIf="item.e_signed" title="Fattura firmata digitalmente" [src]="'assets/icone_varie/signed.svg' " style='width:16px; height:auto'>
                            <img *ngIf="getAllegati(item.tags)" title="La fattura contiene allegati" [src]="'assets/icone_varie/paperclip.svg' " style='width:16px; height:auto'>-->
                            <br/>{{stringToDate(item.data_creazione, "DD-MM-YYYY HH:mm:ss")}}</td>
                        <td class='btnCol'>
                            <div ngbDropdown class="d-inline-block">
                                <button class="btn btn-primary mydropdown" id="dropdownBasic1" ngbDropdownToggle (click)='$event.stopPropagation();'>
                                    <img src="assets/icone_varie/azione.svg" style="width: 25px;">
                                </button>
                                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                    <button ngbDropdownItem (click)="downloadFile('file', item.id, i); $event.stopPropagation()">{{'invoices.dropdown.downloadFile' | translate}}</button>
                                    <button ngbDropdownItem (click)="downloadRelateds(item.notifica); $event.stopPropagation()" *ngIf='item.stato!="Bozza"'>{{'invoices.dropdown.downloadNotific' | translate}}</button>
                                    <button ngbDropdownItem (click)="downloadFile('xml', item.id, i); $event.stopPropagation()"*ngIf='item.stato!="Bozza"'>{{'invoices.dropdown.downloadXml' | translate}}</button>
                                    <button ngbDropdownItem (click)="downloadFile('allegati', item.id, i); $event.stopPropagation()" *ngIf='item.stato!="Bozza"'>{{'invoices.dropdown.downloadAllegati' | translate}}</button>
                                    <button ngbDropdownItem (click)="goToEditorDuplica(item.id); $event.stopPropagation()" *ngIf='item.stato!="Bozza"'>Duplica fattura</button>
                                    <button ngbDropdownItem (click)="showPreviewMinisteriale(item.id, item.file_name, i); $event.stopPropagation()">{{'invoices.dropdown.preview' | translate}}</button>
                                    <button ngbDropdownItem *ngIf='item.stato!="Bozza"' (click) = "openEmailModal(item.id); $event.stopPropagation()">{{'invoices.dropdown.sendMail' | translate}}</button>
                                    <button ngbDropdownItem *ngIf='item.stato=="Bozza"' (click)="goToEditor(item.id); $event.stopPropagation()" >{{'invoices.dropdown.modify' | translate}}</button>
                                    <button ngbDropdownItem *ngIf='item.stato=="Bozza" || item.stato=="Scartata"' (click)="cancellaBozza(item.id); $event.stopPropagation()" >{{'invoices.dropdown.delete' | translate}}</button>
                                    <button ngbDropdownItem *ngIf='item.stato=="Scartata"' (click)="hideFromDashboard(item.id); $event.stopPropagation()" >{{'invoices.dropdown.hideFromDashboard' | translate}}</button>
                                    <button ngbDropdownItem *ngIf='item.stato=="In conservazione"' (click)="importNotifica.click(); impostaFattura(item.id); $event.stopPropagation()">Carica notifica</button>
                                    <button ngbDropdownItem *ngIf='item.stato!="Inviata" && item.stato != "Bozza"' (click)="getNotifications(item.notifica); $event.stopPropagation()">Mostra notifiche</button>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

    </div>
    <br>

    

</ng-container>
<ng-template #noRes>
    <div>
      <ngb-toast [autohide]="false" class="warning">
          <img src="assets/icone_varie/info.png" style="width: 20px; margin-right: 5px;">
          {{'general.noResults' | translate}}
      </ngb-toast>
    </div>
  </ng-template>


    

    <ng-template #info>
        <ngb-toast [autohide]="false" class="default">
            <img src="assets/icone_varie/info.png" style="width: 20px; margin-right: 5px;">

            <!-- {{'general.insertFilter' | translate}} -->
        </ngb-toast>
    </ng-template>
</ng-container>

<input type="file" name="my_file" #importNotifica style="visibility: hidden;" (change)="loadNotificaInConserva($event)">

<ng-template #waiting>
    <app-loading></app-loading>
</ng-template>

